'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var utilities_combineClasses = require('../_chunks/combineClasses-5P8GTQkg.js');
var theme_index = require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');

require("../_assets/ThemeProvider-BmcgqBXl.css");var styles = {"defaultTheme":"ThemeProvider__7C5iKgsxCC__defaultTheme"};

const ThemeProvider = react.forwardRef(({ className, style, ...props }, ref) => {
    return (jsxRuntime.jsx("div", { className: utilities_combineClasses.combineClasses(styles.defaultTheme, className), style: theme_index.GlobalFeatureFlags.DesignSystemRoundedCorners
            ? style
            : {
                '--border-radius-100': theme_index.theme.borderRadius.rounded,
                '--border-radius-200': theme_index.theme.borderRadius.rounded,
                ...style,
            }, ...props, ref: ref }));
});
ThemeProvider.displayName = 'ThemeProvider';

exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map
